import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CampusProofCard} from './CampusProofCard';
import {CampusButton} from '../Components/CampusButton';
import {ProductSelector} from '../ProductSelector/ProductSelector';
import {browserHistory} from 'react-router';

/* root for image */
declare var ImageRoot: string;

class ProductProps extends Tgcc.BaseProps {
    product: Tgcc.Product;
}

const imgStyle: React.CSSProperties = {
    maxHeight: '180px',
    maxWidth: '180px',
    height: 'auto',
    width: 'auto',
    alignSelf: 'center',
    display: 'flex'
}

const labelStyle: React.CSSProperties = {
    fontFamily: 'Lulo',
    fontSize: '11px',
    letterSpacing: '1px',
    textTransformm: 'uppercase'
}

const cStyle: React.CSSProperties ={
    display: 'flex',
    flexDirection: "column",
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
    marginTop:'10px'
}
const productText: React.CSSProperties = {
    fontFamily:'BarlowLight',
    color:'#626161',
    width:'75%',
    textAlign:'center',
    margin:'auto auto'
}

const productText1: React.CSSProperties = {
    fontFamily:'BarlowLight',
    color:'rgb(97, 96, 96)',
    textAlign:'center',
    fontSize:'12px',
    margin:'20px auto',
    width:'75%'
}

class _MajorAccountsProductEdit extends React.Component<ProductProps, Tgcc.GlobalState> {

    openProduct = () => {browserHistory.push(Tgcc.Routes.MajorAccountsProductListView)}

    handleMissingProductImage = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProductImageSrc;
    }

    getProductImage(){
        if(this.props.product){
            var p = this.props.product;
            var image = Tgcc.getProductPath(this.props.product.thumbnail.replace(' ', '%20'))
            return ( 
                <div style={cStyle}>
                    <img src={image} style={imgStyle} onError={this.handleMissingProductImage}/>
                    <div style={labelStyle}>{p.brand}&nbsp;{p.style}</div>
                    <div style={labelStyle}>{p.colorName}</div>
                </div>
            );
        }
    }


    render() {
        var btnText: string = this.props.product ? "Change apparel" : "Choose apparel";
        return (
            <div>
                <CampusProofCard title="2. Apparel" fontFamily="Lulo">
                    { this.getProductImage() }
                    <div>
                    <CampusButton text={btnText}  onClick={this.openProduct} lineHeight="3.0em" margin='auto' fontSize='10px' fontFamily='Lulo' border='1px solid black'/>
                    </div>
                    <div style={productText1}>If you don&#39;t see what you need, let us know in additional notes.</div>
                </CampusProofCard>
            </div>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { product: state.ActiveProof.product }
};

export var MajorAccountsProductEdit = connect(mapStateToProps)(Radium(_MajorAccountsProductEdit));